import $ from 'jquery';
import tryOpen from 'common/js/openApp';

var _ua = navigator.userAgent;
const utils =  {
    isDebug: process.env.RUN_TYPE_EVN !== 'development' ? false : true,
    isWap: /Mobile/i.test(_ua),
    isWx:  /MicroMessenger/i.test(_ua.toLowerCase()),
    isQQBrowser : _ua.indexOf('QQBrowser') > -1 ,//QQ浏览器打开
    isAndroid: _ua.indexOf('Android') > -1 || _ua.indexOf('Adr') > -1,
    isIOS: !!_ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
    iosVer: _ua.match(/os\s+(\d+)/i) && _ua.match(/os\s+(\d+)/i)[1] - 0,
    iosVer2: _ua.match(/os\s+(\d+)/i) && _ua.match(/os\s+(\d+)_(\d+)/i)[2] - 0,

	/**
	 * 异步加载js
	 * @param url
	 * @returns {Promise}
	 */
	load: function(url) {
		return new Promise(function(resolve, reject) {
			var script = document.createElement('script');
			script.type = 'text/javascript';
			script.async = true;
			script.src = url;
			script.onload = resolve;
			script.onerror = reject;
			document.head.appendChild(script);
		})
	},


	/**
     * 数组去重
     * @param arr {Array} 需去重的数组
     */
    unique: function(arr, key) {
	    let newArr = [],
		    map = {};

	    for(let i = 0, len = arr.length; i < len; i++) {
		    let item = arr[i];
		    if(!map[item[key]]) {
			    newArr.push(item);
			    map[item[key]] = true;
		    }
	    }
	    return newArr;
    },

    /**
     * 微信浏览器判断
     * @param callback {Function} 非微信浏览器的回调处理
     */
    isWxBrowser: function(callback) {
        if(!this.isWx) {
            callback && callback({
                type: 'fail',
                txt: '请在微信中打开本页面'
            });
            return false;
        }
        return true;
    },

    /**
     * 事件绑定 移动端click会转为touchstart,规避click冒泡失效的问题
     * @param obj {DOM} 事件绑定对象
     * @param type {String} 事件名称
     * @param fn   {Function} 方法
     */
    addEvent: function(obj, type, fn){
        if(type === 'click'){
            if("ontouchstart" in document) {
                type = 'touchstart'
            }
        }

        obj.addEventListener(type, fn, false);
    },
    /**
     * 事件解绑 移动端click会转为touchstart,对应addEvent处理
     * @param obj {DOM} 事件移除对象
     * @param type {String} 事件名称
     * @param fn   {Function} 方法
     */
    removeEvent: function(obj, type, fn) {
        if(type === 'click'){
            if("ontouchstart" in document) {
                type = 'touchstart'
            }
        }

        obj.removeEventListener(type, fn, false);
    },
    /**
     * 函数节流方法
     * @param {Function} fn 延时调用函数
     * @param {Number} delay 延迟多长时间
     * @param {Number} atleast 至少多长时间触发一次
     * @return {Function} 延迟执行的方法
     */
    throttle: function(fn,delay, atleast) {
        let timer = null;
        let previous = null;

        return function () {
            let now = +new Date();

            if ( !previous ) previous = now;

            if ( now - previous > atleast ) {
                fn();
                // 重置上一次开始时间为本次结束时间
                previous = now;
            } else {
                clearTimeout(timer);
                timer = setTimeout(function() {
                    fn();
                }, delay);
            }
        }
    },
    /**
     * 数字格式化(以万为基准)
     * @param val    {Number} 需格式化的数值
     * @param ...args   {Number||String} 不定参[保留小数位置|单位]  单位[默认：w]
     */
    formatNumber: function(val, ...args) {
        var base = 10000,
            dig = 2,
            unit = "w";

        for(var arg of args) {
            if(typeof arg === 'string') {
                unit = arg;
            }else if(typeof arg === 'number') {
                dig = arg;
            }
        }

        if(val < base) {
            return val;
        }else{
            return ((val / 10000 * 100).toFixed(dig) / 100 + unit);
        }
    },
	createIframe: function(url, callback) {
		let oIframe = document.querySelector("iframeHide");
		if(!document.querySelector("iframeHide")) {
			let iframe = document.createElement("iframe");
			iframe.setAttribute("src", url);
			iframe.style.display="none";
			document.body.appendChild(iframe);
		}else{
			oIframe.onload = function() {
				callback && callback();
			}
			oIframe.setAttribute("src", url);
		}

	},
    /**
     * 请求封装
     * @param options {Object} 请求相关参数
     * @return 请求句柄  {Deferred}
     */
    jsonp: function(options){
        return $.ajax($.extend({
            dataType: 'jsonp',
            cache:true,
        },options));
    },
    /**
     * query参数格式化
     * @param query    {String} 不带?的query参数
     * @return 格式化后的query  {Object}
     */
    parseQuery: function(query) {
        if(!!query){
            var reg = /([^=&\s]+)[=\s]*([^=&\s]*)/g;
            var obj = {};
            while(reg.exec(query)){
                obj[RegExp.$1] = RegExp.$2;
            }
            return obj;
        }

        return null;
    },
    /**
     * 设置页面标题
     * @param newTitle {string} 新名字
     */
   setDocTitle(newTitle){
        document.title = newTitle  || '虎牙直播-高颜值美女现场';
    },
    /**
     *  跳转app
     */
    openApp(){
        tryOpen();
    },
    /**
     * 开启onerror
     */
    openOnerror: function(){
        if( this.isDebug ){
            window.onerror = function(errorMessage, scriptURI, lineNumber,columnNumber,errorObj) {
                console.log("错误信息：" , errorMessage);
                alert(["出错文件：" + scriptURI , "出错行号：" +  lineNumber," 出错列号：" + columnNumber, "错误详情：" + errorObj]);

            }
        }
    },
    /**
     *  要打印
     * @param {string} msg 要打印的信息
     * @color {string} color 颜色
     */
    log: function(msg, color){
        if( this.isWap ){
            var debug =  document.getElementById('debugger');
            if( !debug ){
                debug = document.createElement('div');
                debug.id = "debugger";
                debug.style.cssText="position:absolute;top:50%;left:0;right:0;padding:10px;color:red;font-size:0.5rem;z-index:200;word-break:break-all;";
                document.body.appendChild(debug);
            }
            debug.innerHTML  += ('['+ msg + ']');

        }else{
            color = color || '#fff';
            console.log('%c ' + msg,'background:#000;color:'+ color);
        }
    },
    /**
     * wap需要cookie时
     */
    setDebuggerCookie(cookie){
        setcookieByStr(cookie);
    },
    /**
     * 清除cookie
     */
    clearCookie(cookie){
        setcookieByStr(cookie, -1);
    }
}

function setcookieByStr(str, expire){
    (str.split(';') || []).forEach(function( item ){
        setcookie(item, expire);
    })
}
function setcookie(namevalue, expire) {
    var arr = namevalue.split('='),
        name = arr[0],
        value = arr[1];

    var d = new Date();
    if (expire) {
        d.setTime(d.getTime() + expire);
    } else {
        d.setTime(d.getTime() + (100 * 365 * 24 * 60 * 60 * 1000));
    }

    var expires = 'expires=' + d.toUTCString();

    value = encodeURI(value);
    document.cookie = name + '=' + value + '; ' + expires + ';domain=.huya.com;path=/';
}

const queryParams = utils.parseQuery(window.location.search.substr(1)) || {};
utils.appId = queryParams['promoter'] || queryParams['channel'] || 'huya_h5_10';//获得渠道号
utils.hideHeader = !!(+(queryParams['hideHeader'] || queryParams['hideheader'] || 0));//隐藏头尾
utils.hideGift =  !!(+(queryParams['hideGift'] || queryParams['hidegift'] || 0 ));//隐藏充值和礼物入口
utils.gid = queryParams['gid'] || -2;//获得gid
utils.tid = queryParams['tid'] || 0;//获得tid
utils.hcol = queryParams['hcol'] || 3;//获得首页列数
utils.openOnerror();
export default utils;


// WEBPACK FOOTER //
// ./src/common/js/utils.js